module.exports = __webpack_public_path__ + "static/img/数字内容创意1.802d037a.png";